import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/components/site/theme";
import { EnquiryProvider } from "@/components/site/EnquiryDialog";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import RecentEnrollment from "@/components/site/RecentEnrollment";
import Backdrop from "@/components/site/Backdrop";
import Home from "@/pages/Home";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import Packages from "@/pages/Packages";
import PackageDetail from "@/pages/PackageDetail";
import Instructors from "@/pages/Instructors";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import DashboardLayout from "@/components/dashboard/Layout";
import Overview from "@/pages/user/Overview";
import MyCourses from "@/pages/user/MyCourses";
import CoursePlayer from "@/pages/user/CoursePlayer";
import Certificates from "@/pages/user/Certificates";
import Partner from "@/pages/user/Partner";
import { Team, Leaderboard } from "@/pages/user/TeamBoard";
import { Profile, ChangePassword, Billing, Support } from "@/pages/user/Account";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminPayouts from "@/pages/admin/AdminPayouts";
import { AdminLeaderboard, AdminPackages, AdminEnquiries } from "@/pages/admin/AdminMisc";
import ThemeSwitch from "@/components/site/ThemeSwitch";
import { AuthProvider, Protected } from "@/components/site/auth";

const ScrollTop = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    const ref = new URLSearchParams(search).get("ref");
    if (ref) localStorage.setItem("ilmora-ref", ref.toUpperCase());
  }, [search]);
  return null;
};

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
        <EnquiryProvider>
          <ScrollTop />
          <Backdrop />
          <Header />
          <main className="relative z-10">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/courses/:slug" element={<CourseDetail />} />
              <Route path="/packages" element={<Packages />} />
              <Route path="/packages/:slug" element={<PackageDetail />} />
              <Route path="/instructors" element={<Instructors />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<Protected><DashboardLayout /></Protected>}>
                <Route index element={<Overview />} />
                <Route path="courses" element={<MyCourses />} />
                <Route path="courses/:slug" element={<CoursePlayer />} />
                <Route path="certificates" element={<Certificates />} />
                <Route path="partner" element={<Partner />} />
                <Route path="team" element={<Team />} />
                <Route path="leaderboard" element={<Leaderboard />} />
                <Route path="billing" element={<Billing />} />
                <Route path="profile" element={<Profile />} />
                <Route path="password" element={<ChangePassword />} />
                <Route path="support" element={<Support />} />
              </Route>
              <Route path="/admin" element={<Protected admin><AdminLayout /></Protected>}>
                <Route index element={<AdminDashboard />} />
                <Route path="students" element={<AdminUsers />} />
                <Route path="approvals" element={<AdminUsers onlyPending />} />
                <Route path="payouts" element={<AdminPayouts />} />
                <Route path="leaderboard" element={<AdminLeaderboard />} />
                <Route path="packages" element={<AdminPackages />} />
                <Route path="enquiries" element={<AdminEnquiries />} />
              </Route>
            </Routes>
          </main>
          <Footer />
          <RecentEnrollment />
          <ThemeSwitch />
          <Toaster position="top-center" richColors />
        </EnquiryProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
